import { FC } from 'react';
import { Grid, GridProps } from '@mui/material';

export const gridSpacing = 2 satisfies GridProps['spacing'];

export const FullWidthGridItem: FC<GridProps> = props => (
  <Grid size={12} spacing={gridSpacing}>
    <Grid {...props} />
  </Grid>
);
